import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'home',
  props: [],
  mounted () {
  },
  data () {
    return {
      mailsent:false,
      name: '',
      email: '',
      message:'',
      valid:false,
      nameRules:[
        (v) => !!v || 'Name is required'
      ],
      emailRules:[
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      contentRule:[
        (v) => !!v || 'Message is required'
      ]
    }
  },
  methods: {
    createLink (action, param) {
      return action + ':' + param
    },
    submit () {
      this.actContact({
        email:this.email,
        name: this.name,
        body:this.message
      }).then(x=>{
        this.clear()
        this.mailsent = true
      })
    },
    clear () {
      this.name = ''
      this.email = ''
      this.message = ''
      this.valid = false
    },
    ...mapActions([
      'actContact'
    ])
  },
  computed: {
    ...mapGetters({
      categories: 'getCatagories',
      products: 'getProducts',
      staticText: 'getStaticText'
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.component.js